import React from "react";
import styles from "./content.module.scss";
import { Route, Switch } from "react-router";
import JobRequestsBar from "../sections/sideBars/JobRequestsBar";
import JobRequestsMap from "../sections/contentBlocks/JobRequestsMap";

const JobRequestContent = (props) => {
  return (
    <div className={props.isSideBarOpen ? styles.content : styles.content_closedBar}>
      <Switch>
        <Route exact path={["/jobRequests"]}>
          <div className={styles.container_sideBar}>
            <JobRequestsBar />
          </div>

          <div className={styles.container_sideContent}>
            <Switch>
              <Route exact path={["/jobRequests"]} component={JobRequestsMap} />
            </Switch>
          </div>
        </Route>
      </Switch>
    </div>
  );
};

export default React.memo(JobRequestContent);
